import {
  DateRangeFilterValueLike,
  dateRangeFilterValueToRange,
} from '@app/components/date-range-selector/date-range/date-range-filter-value-to-range';
import { ListViewFilters, ListViewSort } from '@app/core/list-view/types';

/**
 * Maps ListView filters into `fetchReports` args for GIP / GIP alt.
 */
export function savedReportsGipFiltersToApi(
  filters: ListViewFilters | null | undefined,
  timezone: string,
): {
  nameLike?: string;
  createdAtFrom?: string;
  createdAtTo?: string;
  onlyMine: boolean;
} {
  const dateRange = (filters?.dateRange ?? null) as DateRangeFilterValueLike | null;
  const { from, to } = dateRangeFilterValueToRange(dateRange, { timezone });
  const name = typeof filters?.name === 'string' ? filters.name.trim() : '';
  const onlyMine = filters?.onlyMine !== false;

  return {
    nameLike: name || undefined,
    createdAtFrom: from,
    createdAtTo: to,
    onlyMine,
  };
}

/**
 * Builds the `/reports` sort string. Defaults to newest first.
 */
export function savedReportsGipSortToApi(sort: ListViewSort | null | undefined): string {
  if (!sort?.id) {
    return 'createdAt desc';
  }

  return `${sort.id} ${sort.desc ? 'desc' : 'asc'}`;
}
